<template>
  <div class="pipe-extraction bg-transparent rounded-2px z-99 w-full h-full pt-10px">
    <el-row :gutter="10" class="pr-5px mt-10px">
      <el-col :span="12">
        <el-input
          size="small"
          v-model="keywords"
          placeholder="请输入管线位号"
          clearable
          @clear="searchHandler"
        ></el-input>
      </el-col>
      <el-col :span="12" class="search-wrap flex items-center mb-10px">
        <el-button @click="searchHandler" size="small" type="primary">搜索</el-button>
        <div
          class="extracted-box border-1 border-solid border-[#629eaa] h-36px w-80px flex items-center ml-10px justify-center rounded-2px bg-[#43adb72b]"
        >
          <span class="whitespace-nowrap text-[#fff] text-14px">抽离</span>
          <el-checkbox
            class="ml-5px !mb-0px"
            v-model="allFlowStatus"
            :disabled="allFlowDisabled"
            @change="changeAllStatus"
          ></el-checkbox>
        </div>
      </el-col>
    </el-row>
    <el-table
      v-loading="tableLoading"
      ref="markerTable"
      :data="tableData"
      height="calc(100% - 104px)"
      :row-key="(row) => row.tagId"
      class="markerTable"
      stripe
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ 'text-align': 'center' }"
      :highlight-current-row="true"
      @selection-change="handleSelectionChange"
      @row-click="moveToPipe"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column show-overflow-tooltip prop="Code" label="管线位号"></el-table-column>
      <el-table-column show-overflow-tooltip prop="Name" label="管线名称"></el-table-column>
      <el-table-column show-overflow-tooltip label="抽离状态">
        <template slot-scope="{ row }">
          <span :class="row.status ? 'text-[#20c1d8]' : ''">{{
            row.status ? '抽离' : '未抽离'
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @current-change="getTableData"
      :current-page.sync="page.pageNo"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
      :pager-count="5"
      class="flex justify-end mt-10px"
    ></el-pagination>
  </div>
</template>

<script>
import { isEmpty, findIndex, filter, map, forEach } from 'lodash'
import DiyCodeService from '../../../service/DiyCodeService'
import HandoverService from '../../../service/HandoverService'

export default {
  components: {},
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      allFlowDisabled: true,
      allFlowStatus: false, // 批量流向动画展示
      tableLoading: false,
      treeFilterKey: null,
      curRootItem: null, // 当前根节点
      currentDeviceId: null, // 当前装置id
      currentModelId: null, // 当前的模型id
      standardId: '',
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      keywords: '',
      tableData: [],
      currentShowPipes: [], // 当前已经创建的动画
      currentSelectedPipe: [], // 表格多选
    }
  },
  computed: {
    // 可视化头部组件
    pipeTableName() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit-tongre"].config')
          ?.pipeTableName || 'diy_pipeline_management'
      )
    },
  },
  watch: {},
  async created() {
    this.searchHandler()
    this.getStandardList()
  },
  async beforeDestroy() {
    this.player.Native.ModelTree.setSelectItem(0)
    // 获取根节点
    const rootInfo = await this.player.Native.ModelTree.getRootItems()
    if (rootInfo?.length && rootInfo[0].item) {
      // 恢复模型状态
      await this.player.Native.ModelTree.setItemVisible([rootInfo[0].item], true)
    }
  },
  methods: {
    // 装置树检索
    filterTreeNode(value, data) {
      if (!value) return true
      return data.deviceName.indexOf(value) !== -1
    },
    // 滑块format
    tooltipFormat(val) {
      return (val / 100).toFixed(1)
    },
    // 重置数据
    async resetData() {
      this.currentShowPipes = [] // 清空动画列表
      this.currentSelectedPipe = [] // 清空多选
      this.tableData = [] // 清空表单
    },
    // 表格多选
    handleSelectionChange(val) {
      this.currentSelectedPipe = val
      this.resetSwitchStatus()
    },
    // 初始化装置状态
    async initDevice() {
      const rootInfo = await this.player.Native.ModelTree.getRootItems()
      if (rootInfo?.length && rootInfo[0].item) {
        this.curRootItem = rootInfo[0].item
        await this.player.Native.ModelTree.setItemVisible([rootInfo[0].item], false)
      }
    },
    // 重置装置透明度
    async resetDevice() {
      const rootInfo = await this.player.Native.ModelTree.getRootItems()
      if (rootInfo?.length && rootInfo[0].item) {
        await this.player.Native.ModelTree.setItemVisible([rootInfo[0].item], true)
      }
    },
    // 全量修改抽离状态
    async changeAllStatus() {
      if (this.allFlowStatus) {
        // 打开
        try {
          const needOpenPipes = filter(this.currentSelectedPipe, ['status', false])
          if (needOpenPipes?.length) {
            const itemInfoPromises = map(needOpenPipes, (pipe) => {
              return this.player.Native.ModelTree.findItemByCode(pipe.Code, this.curRootItem)
            })
            const itemInfoRes = await Promise.all(itemInfoPromises)
            const itemList = map(itemInfoRes, (it) => {
              return it.item
            })
            await this.player.Native.ModelTree.setItemVisible(itemList, true)
            for (let j = 0; j < needOpenPipes.length; j += 1) {
              this.currentShowPipes.push({
                code: needOpenPipes[j].Code,
                item: itemInfoRes[j].item,
              })
            }
            // 同步更新对应操作列开关状态
            const codeList = map(needOpenPipes, 'Code')
            forEach(this.tableData, (item) => {
              if (codeList.includes(item.Code)) {
                item.status = true
              }
            })
          }
        } catch (error) {
          console.error(`管线抽离出错了  ${error}`)
        }
      } else {
        const needClosePipes = filter(this.currentSelectedPipe, ['status', true])
        const needCloseItem = []
        for (let i = 0; i < needClosePipes.length; i += 1) {
          const showIndex = findIndex(this.currentShowPipes, ['code', needClosePipes[i].Code])
          if (showIndex > -1) {
            needCloseItem.push(this.currentShowPipes[showIndex].item)
          }
        }
        await this.player.Native.ModelTree.setItemVisible(needCloseItem, false)
        const closedCodes = map(needClosePipes, 'Code')
        this.currentShowPipes = filter(this.currentShowPipes, (item) => {
          return !closedCodes.includes(item.code)
        })
        // 更新表中开关状态
        forEach(this.tableData, (item) => {
          if (closedCodes.includes(item.Code)) {
            item.status = false
          }
        })
      }
    },
    // 获取管线表数据
    async getTableData() {
      this.tableLoading = true
      const data = {
        TableName: this.pipeTableName || 'diy_pipeline_management',
        _PageIndex: this.page.pageNo,
        _PageSize: this.page.pageSize,
      }
      if (this.keywords) {
        data._Where = [
          {
            Name: 'Code',
            Type: 'Like',
            Value: this.keywords,
          },
        ]
      }
      const [err, res] = await DiyCodeService.getPipesData(data)
      this.tableLoading = false
      if (!err && res && res.Data) {
        this.tableData = res.Data
        this.page.total = res.DataCount
      }
      this.currentShowPipes = []
      await this.initDevice()
      const itemInfoPromises = map(this.tableData, (pipe) => {
        return this.player.Native.ModelTree.findItemByCode(pipe.Code, this.curRootItem)
      })
      const itemInfoRes = await Promise.all(itemInfoPromises)
      const itemList = map(itemInfoRes, (it) => {
        return it.item
      })
      await this.player.Native.ModelTree.setItemVisible(itemList, true)
      for (let j = 0; j < this.tableData.length; j += 1) {
        this.currentShowPipes.push({
          code: this.tableData[j].Code,
          item: itemInfoRes[j].item,
        })
      }
      forEach(this.tableData, (item) => {
        this.$set(item, 'status', true)
      })
    },
    // 当单个管线的按钮状态切换时，调整总体抽离开关状态
    resetSwitchStatus() {
      if (this.currentSelectedPipe?.length) {
        this.allFlowDisabled = false
        const codeWithAnimation = map(this.currentShowPipes, (item) => {
          return item.code
        })
        let hasNoAnimationPipe = false
        // 判断多选项里是否有还未加载动画的管线
        try {
          forEach(this.currentSelectedPipe, (item) => {
            if (!codeWithAnimation.includes(item.Code)) {
              hasNoAnimationPipe = true
              throw new Error()
            }
          })
          // eslint-disable-next-line no-empty
        } catch (e) {}
        if (hasNoAnimationPipe) {
          // 有未打开抽离的管线、将状态改为false
          this.allFlowStatus = false
        } else {
          // 无未打开的抽离，则按钮为true，可执行关闭操作
          this.allFlowStatus = true
        }
      } else {
        this.allFlowDisabled = true
      }
    },
    // 搜索
    searchHandler() {
      this.page.pageNo = 1
      this.getTableData()
    },
    async getStandardList() {
      const [err, res] = await HandoverService.getStandardList()
      if (!err && res && res.code === 0 && res.data?.length) {
        this.standardId = res.data[0].id
      } else {
        this.standardId = ''
      }
    },
    async moveToPipe(row) {
      if (row.Code) {
        this.player.Native.Camera.moveToCode(row.Code, 2)
        const itemInfo = await this.player.Native.ModelTree.findItemByCode(
          row.Code,
          this.curRootItem
        )
        if (itemInfo && itemInfo.item) {
          this.player.Native.ModelTree.setSelectItem(itemInfo.item)
        }
      }
      this.$emit('transferEvent', {
        toCom: { code: 'ObjectInfoDyw', origin: 'HandoverObjectDyw', name: '对象信息' },
        type: 'mainComponent',
        props: {
          code: row.Code,
          flag: 0,
          standardId: this.standardId,
          openAlarmFlicker: true,
          flickerFrequency: 500,
        },
      })
    },
  },
}
</script>
<style lang="scss">
.visualization-select-popper {
  .el-select-dropdown__list {
    padding: 5px !important;
  }
}
</style>
<style lang="scss" scoped>
.markerTable {
  ::v-deep .el-checkbox {
    margin: 0 !important;
  }
  ::v-deep .el-table th.is-leaf,
  .el-table td {
    border: none !important;
  }
}
::v-deep.device-tree {
  overflow-y: auto;
  height: 100%;
  color: #fff;
  background-color: transparent !important;

  .el-tree-node__content:hover {
    background: #0499a744 !important;
  }

  .el-tree-node.is-current > .el-tree-node__content {
    background: #049aa780 !important;
  }

  .el-tree-node:focus > .el-tree-node__content {
    background: #049aa780 !important;
  }
  .el-tree-node__label {
    color: #fff !important;
  }

  .custom-tree-node {
    width: 100%;
    font-size: 14px;
  }
}
.pipe-extraction {
  ::v-deep .el-slider__bar {
    background: #11939d !important;
  }
  ::v-deep .el-input__inner {
    background: url('../../../assets/images/cockpitNew/input-bg.png') no-repeat !important;
    border: none !important;
    background-size: 100% 100% !important;
    border-radius: unset !important;
  }
  ::v-deep .el-slider__button {
    width: 10px !important;
    height: 10px !important;
    border: 2px solid #11939d !important;
  }
  .search-wrap {
    ::v-deep .el-button {
      background-color: rgb(67 153 174 / 35%) !important;
      background-image: none !important;
      border: 1px solid #629eaa !important;
      border-radius: 2px !important;
      height: 36px !important;
    }
    ::v-deep .el-checkbox__inner {
      width: 18px !important;
      height: 18px !important;
      background-color: transparent !important;
      border-color: #30edff !important;
      &::after {
        display: none;
      }
    }
  }
  .markerTable {
    ::v-deep .el-checkbox__inner {
      background-color: transparent !important;
      border-color: #adadad !important;
      &::after {
        left: 4px !important;
        top: 0px !important;
      }
    }
    ::v-deep .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: transparent !important;
      border-color: #fff !important;
    }
    ::v-deep .el-table__body tr.el-table__row--striped td.el-table__cell {
      background-color: transparent !important;
    }
    ::v-deep .el-table__row.el-table__row--striped {
      background: linear-gradient(0deg, #17c5dc5e, #1de3fd1a);
    }
    ::v-deep .el-table__body .current-row {
      background: linear-gradient(0deg, #986c36, #986c3666);
    }
  }
}
::v-deep {
  .el-pagination.is-background.el-pagination--small .btn-next,
  .el-pagination.is-background.el-pagination--small .btn-prev,
  .el-pagination.is-background.el-pagination--small .el-pager li {
    padding: 0 !important;
    margin: 0 3px !important;
  }
}
.box-shadow {
  box-shadow: 0 0 8px #00fbf2;
}
</style>
